import React, { useState, useEffect } from 'react';
import { bonusFeatures } from '../data/mock';
import Lottie from 'lottie-react';

const BonusFeatures = () => {
  const [lottie1, setLottie1] = useState(null);
  const [lottie2, setLottie2] = useState(null);
  const [lottie3, setLottie3] = useState(null);
  const [lottie4, setLottie4] = useState(null);
  const [lottie5, setLottie5] = useState(null);
  const [lottie6, setLottie6] = useState(null);

  useEffect(() => {
    fetch('/images/1.4.json')
      .then(response => response.json())
      .then(data => setLottie1(data))
      .catch(error => console.error('Error loading Lottie 1.1:', error));
    
    fetch('/images/1.6.json')
      .then(response => response.json())
      .then(data => setLottie2(data))
      .catch(error => console.error('Error loading Lottie 1.2:', error));
    
    fetch('/images/1.3.json')
      .then(response => response.json())
      .then(data => setLottie3(data))
      .catch(error => console.error('Error loading Lottie 1.3:', error));
    
    fetch('/images/1.5.json')
      .then(response => response.json())
      .then(data => setLottie4(data))
      .catch(error => console.error('Error loading Lottie 1.4:', error));
    
    fetch('/images/1.1.json')
      .then(response => response.json())
      .then(data => setLottie5(data))
      .catch(error => console.error('Error loading Lottie 1.5:', error));
    
    fetch('/images/1.2.json')
      .then(response => response.json())
      .then(data => setLottie6(data))
      .catch(error => console.error('Error loading Lottie 1.6:', error));
  }, []);
  return (
    <section id="why-us" className="bg-black text-white py-20 px-6">
      <div className="mx-auto max-w-7xl">
        {/* Section Header */}
        <div className="text-center mb-16">
          <p className="text-sm text-gray-400 uppercase tracking-wider mb-4 font-inter font-medium">Why Us</p>
          <h2 className="text-3xl md:text-5xl font-black leading-tight font-mosans">
            What Makes Us Different
          </h2>
        </div>

        {/* Bento Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-4">
          {bonusFeatures.map((feature, index) => {
            const bgColors = [
              'bg-[#C84B8A]',
              'bg-[#FFB8D8]',
              'bg-[#B897E3]',
              'bg-[#FF6B35]',
              'bg-[#FFD6BA]',
              'bg-[#E8D5C4]'
            ];

            const getGridClass = () => {
              if (index === 1) return 'md:col-span-2 lg:col-span-2';
              if (index === 3) return 'md:col-span-2';
              return '';
            };

            return (
              <div
                key={index}
                className={`${
                  bgColors[index % bgColors.length]
                } ${getGridClass()} rounded-3xl p-8 hover:scale-105 transition-transform duration-300 cursor-pointer group relative overflow-hidden min-h-[200px] flex flex-col justify-between`}
              >
                <div>
                  <h3 className="text-xl md:text-2xl font-bold mb-3 text-black font-mosans">
                    {feature.title}
                  </h3>
                  <p className="text-sm md:text-base text-black/80 font-inter">
                    {feature.description}
                  </p>
                </div>

                {index === 0 && lottie1 ? (
                  <div className="mt-6">
                    <Lottie 
                      animationData={lottie1}
                      loop={true}
                      className="rounded-xl w-full h-32"
                    />
                  </div>
                ) : index === 1 && lottie2 ? (
                  <div className="mt-6">
                    <Lottie 
                      animationData={lottie2}
                      loop={true}
                      className="rounded-xl w-full h-48 md:h-56"
                    />
                  </div>
                ) : index === 2 && lottie3 ? (
                  <div className="mt-6">
                    <Lottie 
                      animationData={lottie3}
                      loop={true}
                      className="rounded-xl w-full h-48 md:h-56"
                    />
                  </div>
                ) : index === 3 && lottie4 ? (
                  <div className="mt-6">
                    <Lottie 
                      animationData={lottie4}
                      loop={true}
                      className="rounded-xl w-full h-48 md:h-56"
                    />
                  </div>
                ) : index === 4 && lottie5 ? (
                  <div className="mt-6">
                    <Lottie 
                      animationData={lottie5}
                      loop={true}
                      className="rounded-xl w-full h-48 md:h-56"
                    />
                  </div>
                ) : index === 5 && lottie6 ? (
                  <div className="mt-6">
                    <Lottie 
                      animationData={lottie6}
                      loop={true}
                      className="rounded-xl w-full h-48 md:h-56"
                    />
                  </div>
                ) : feature.image ? (
                  <div className="mt-6">
                    <img
                      src={feature.image}
                      alt={feature.title}
                      className="rounded-xl w-full h-32 object-cover"
                    />
                  </div>
                ) : null}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default BonusFeatures;
